<template>
  <div class="services">
    <div class="services__border-top"></div>
    <div class="services__content">
      <div class="services__title fs-60" data-split-context>
        <h3 data-split>
          {{ title }}
        </h3>
        <AppMedia class="service__media" :src="media.url" />
      </div>
      <div class="services__list" data-split-context>
        <h4 data-split class="services__label ff-mono sp-12 tt-u fs-12">
          Development
        </h4>
        <ul class="sp-60">
          <li class="fs-24" data-split v-for="el in dev">{{ el.service }}</li>
        </ul>
        <h4 data-split class="services__label ff-mono sp-12 tt-u fs-12">
          Design
        </h4>
        <ul>
          <li class="fs-24" data-split v-for="el in design">
            {{ el.service }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: String, default: null },
  design: { type: Array, default: null },
  dev: { type: Array, default: null },
  media: { type: Object, default: null },
});
</script>

<style lang="scss" scoped>
.services__border-top {
  background: var(--c-text-alt);
  height: 1px;
  left: 0;
  margin-bottom: 1.6rem;
  top: 0;
  transform-origin: left;
  transform: scaleX(0);
  transition: transform 1s ease(smooth);
  width: 100%;

  .services:has(.services__title.is-context-animating) & {
    transform: scaleX(1);
  }
}

.services__content {
  display: flex;
  flex-direction: column;
  position: relative;

  @include mq(desktop) {
    display: grid;
    gap: fluidMap($spacing, 16);
    grid-template-columns: 60% 40%;
  }
}

.services__title {
  position: relative;
  display: flex;
  justify-content: space-between;

  @include mq(desktop) {
    flex-direction: column;
  }

  &:after {
    content: '';
    background: var(--c-text-alt);
    height: calc(100% + 1.6rem);
    position: absolute;
    right: 0;
    top: 0;
    transform-origin: top;
    transform: translateY(-1.6rem) scaleY(0);
    transition: transform 1s ease(smooth);
    width: 1px;

    .services:has(.services__list.is-context-animating) & {
      transform: translateY(-1.6rem) scaleY(1);
    }
  }

  @include mqDown(desktop) {
    &::after {
      content: none;
    }
  }
}

.services__label {
  display: flex;
}

li {
  line-height: 120%;
}

.service__media {
  width: var(--col-1);
  background: var(--c-bg);
  clip-path: inset(50%);
  transition: clip-path 1s ease(smooth);

  .services:has(.services__list.is-context-animating) & {
    clip-path: inset(0%);
  }
}
</style>
